import { Grid, Box } from '@mui/material';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const FilterNameAndIcon = ({ icon, title, children }) => (
  <Grid py={1} px={2}>
    <Grid item container alignItems="center" p={1} display="flex">
      <Box pr={1} pt={0.5}>
        {icon}
      </Box>
      <Box>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
          {title}
        </WsTypography>
      </Box>
    </Grid>
    {children}
  </Grid>
);
export default FilterNameAndIcon;
